import MemberGloDataA from './MemberGloDataA';

export default function MemberGloData({ isOpenA = false }: { isOpenA?: boolean }) {
    return <>{isOpenA && <MemberGloDataA />}</>;
}
